import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import IOwner from 'src/models/IOwner';
import AddressUtil from 'src/util/Address';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import { FieldArray } from 'react-final-form-arrays';
import FormRow from 'src/components/controls/forms/FormRow';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ManageDeviationsPage } from './ManageDeviationsDialog';
import OwnerUtil from 'src/util/OwnerUtil';

export interface ITransferOwnerContainerDialogProps {
    searchOwners: (searchText: string, ownerType: string) => void;
    onTransferContainerCreatedForm: (form: FormApi) => void;
    getOwnerDeviations: (ownerLookupId: number, containerId: number, type: string) => void;
    getTargetOwnerDeviations: (ownerLookupId: number, containerId: number, type: string) => void;
    clearTargetDeviations: () => void;
    changePage: (page: ManageDeviationsPage) => void;
}

export type ITransferOwnerContainerStateProps = {
    originalOwnerDeviations: Array<IOwner>;
    targetOwnerDeviations: Array<IOwner>;
    searchResults?: Array<SearchResult>;
    form: FormApi;
    page: ManageDeviationsPage;
    searchOwnerType: string;
};

type ITransferOwnerContainerState = {
    hasUncheckedDeviations: boolean;
    searchString: string;
};

type ITransferOwnerContainerDialogPageProps = ITransferOwnerContainerDialogProps & ITransferOwnerContainerStateProps;

class TransferOwnerContainer extends React.Component<ITransferOwnerContainerDialogPageProps, ITransferOwnerContainerState> {
    constructor(props: ITransferOwnerContainerDialogPageProps) {
        super(props);
        this.state = {
            hasUncheckedDeviations: false,
            searchString: undefined,
        };
    }

    searchUpdate = _.debounce((searchText: string, ownerType: string) => {
        this.setState({ searchString: searchText });
        this.props.searchOwners(searchText, ownerType);
    }, 300);

    componentDidUpdate(prevProps: ITransferOwnerContainerDialogPageProps) {
        if (!_.isEqual(this.props.targetOwnerDeviations, prevProps.targetOwnerDeviations)) {
            this.props.form.change('targetOwnerDetails', this.props.targetOwnerDeviations);
        }
    }

    resultsList = () => {
        if (this.state.searchString !== undefined) {
            if (this.props.searchResults?.length > 0) {
                const searchResultsView = this.props.searchResults.map((owner, index) => {
                    return (
                        <div className="dialog-card-list" key={owner.id} onClick={() => this.selectOriginalOwner(index)}>
                            <span className="lh-tenth-width">
                                <FormCheckbox label="" name={`owners[${index}].selected`} isDisabled={true} />
                            </span>
                            <span className="lh-fourth-width">{`${owner.id}`}</span>
                            <span className="lh-fourth-width">{`${owner.name}`}</span>
                            <span className="lh-fourth-width">{`${owner.type}`}</span>
                        </div>
                    );
                });
                return <>{searchResultsView}</>;
            } else {
                return <div>No Owners Were Found</div>;
            }
        } else {
            return <div style={{ textAlign: 'center' }}>Enter a ID, First or Last Name to Search for Existing Owners</div>;
        }
    };

    ownerName = (owner: IOwner) => {
        let name = undefined;
        if (owner) {
            const mappedOwner = OwnerUtil.MapOwner(owner);
            name = mappedOwner ? mappedOwner.ownerName() : 'N/A';
        }
        return name;
    };

    selectOriginalOwner = (index: number) => {
        const owners = this.props.searchResults;
        if (!owners) {
            return;
        }
        let anySelected = false;
        for (let i = 0; i < owners.length; ++i) {
            const tempOwner = owners[i];
            if (tempOwner === undefined) {
                continue;
            }
            if (i === index) {
                if (tempOwner.selected) {
                    tempOwner.selected = false;
                } else {
                    tempOwner.selected = true;
                    anySelected = true;
                    this.props.getTargetOwnerDeviations(tempOwner.id, tempOwner.containerOwnerId, tempOwner.type);
                }
            } else {
                tempOwner.selected = false;
            }
            // this.props.form.mutators.update('owners', i, tempOwner);
        }
        if (!anySelected) {
            this.props.clearTargetDeviations();
        }
        this.setState(this.state);
    };

    ownerOriginalDeviations = () => {
        return (
            <>
                <FieldArray name="ownerDetails">
                    {({ fields, meta }) =>
                        fields.map((name, index) => (
                            <div key={name}>
                                <div style={{ maxWidth: '60rem' }}>
                                    <FormRow>
                                        <div>
                                            <div className="owner-detail-info-name">
                                                <label>
                                                    <span>{this.ownerName(this.props.originalOwnerDeviations[index])}</span>
                                                </label>
                                            </div>
                                            <div className="owner-detail-info-address">
                                                <div style={{ justifyContent: 'flex-end' }}>
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    {AddressUtil.concatWithCommas(
                                                        this.props.originalOwnerDeviations[index]?.address?.addressLine1,
                                                        this.props.originalOwnerDeviations[index]?.address?.city,
                                                        this.props.originalOwnerDeviations[index]?.address?.state?.name,
                                                        this.props.originalOwnerDeviations[index]?.address?.zipCode
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </FormRow>
                                </div>
                            </div>
                        ))
                    }
                </FieldArray>
            </>
        );
    };

    ownerTargetDeviations = () => {
        if (this.props.targetOwnerDeviations === undefined) {
            return <></>;
        } else {
            return (
                <>
                    <FieldArray name="targetOwnerDetails">
                        {({ fields, meta }) =>
                            fields.map((name, index) => (
                                <div key={name}>
                                    <div style={{ maxWidth: '60rem' }}>
                                        <FormRow>
                                            <div>
                                                <div className="owner-detail-info-name">
                                                    <label>
                                                        <span>{this.ownerName(this.props.targetOwnerDeviations[index])}</span>
                                                    </label>
                                                </div>
                                                <div className="owner-detail-info-address">
                                                    <div style={{ justifyContent: 'flex-end' }}>
                                                        {/* tslint:disable-next-line:max-line-length */}
                                                        {AddressUtil.concatWithCommas(
                                                            this.props.originalOwnerDeviations[index]?.address?.addressLine1,
                                                            this.props.originalOwnerDeviations[index]?.address?.city,
                                                            this.props.originalOwnerDeviations[index]?.address?.state?.name,
                                                            this.props.originalOwnerDeviations[index]?.address?.zipCode
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </FormRow>
                                    </div>
                                </div>
                            ))
                        }
                    </FieldArray>
                </>
            );
        }
    };

    prevPage = () => {
        this.props.changePage(ManageDeviationsPage.Menu);
        this.props.clearTargetDeviations();
    };

    isMergeDisabled = () => {
        const deviationNotSelected = this.props.targetOwnerDeviations === undefined || this.props.targetOwnerDeviations.length === 0 ? true : false;

        const duplicateDeviation = this.props.targetOwnerDeviations?.some((x) => x.id === this.props.originalOwnerDeviations[0].id);
        return deviationNotSelected || duplicateDeviation;
    };

    public render() {
        return (
            <Form
                onSubmit={() => {
                    return;
                }}
                initialValues={{
                    owners: this.props.searchResults ? this.props.searchResults : [],
                    ownerDetails: this.props.originalOwnerDeviations ? this.props.originalOwnerDeviations : [],
                    targetOwnerDetails: this.props.targetOwnerDeviations ? this.props.targetOwnerDeviations : [],
                    searchText: this.state.searchString,
                }}
                hasFieldArray={true}
                showDebugValues={true}
                onFormCreated={(form) => this.props.onTransferContainerCreatedForm(form)}
            >
                <div>
                    {this.props.page === ManageDeviationsPage.TransferPage && (
                        <div style={{ width: '100rem', height: '60rem' }}>
                            <FormRow>
                                <div style={{ width: '50rem' }}>
                                    <FormTextBox
                                        name="searchText"
                                        label="Search for Existing Owner"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                            this.searchUpdate(e.target.value, this.props.searchOwnerType)
                                        }
                                    />
                                    <div className="owner-search-results">
                                        <div className="dialog-card-list">
                                            <span className="lh-tenth-width" />
                                            <span className="lh-fourth-width">ID</span>
                                            <span className="lh-fourth-width">Name</span>
                                            <span className="lh-fourth-width">Type</span>
                                        </div>
                                        {this.resultsList()}
                                    </div>
                                </div>
                                <div style={{ width: '90rem' }}>
                                    <div>
                                        <div style={{ fontWeight: 'bold', fontSize: 'large', marginBottom: '1rem' }}>Original Owner</div>
                                        <div style={{ overflowY: 'scroll', height: '20rem' }}>{this.ownerOriginalDeviations()}</div>
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 'bold', fontSize: 'large', margin: '3rem 0 1rem 0' }}>Deviations to Merge</div>
                                        <div style={{ overflowY: 'scroll', height: '20rem' }}>{this.ownerTargetDeviations()}</div>
                                    </div>
                                </div>
                            </FormRow>
                            <div style={{ marginTop: '4rem' }}>
                                <Button text="Prev" onClick={() => this.prevPage()} />
                                <Button
                                    text="Merge Preview"
                                    onClick={() => this.props.changePage(ManageDeviationsPage.TransferConfirmation)}
                                    className="ml-1"
                                    disabled={this.isMergeDisabled()}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </Form>
        );
    }
}

export default TransferOwnerContainer;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/TransferOwnerContainer.tsx